import React, { ReactElement } from 'react';

import Link from 'atomic/link/link';
import { addUtmtoURL } from 'helpers/utm';

import './header.scss';

interface CompanyViewInfoHeaderProps {
    name: string;
    url?: string;
}

const CompanyViewInfoHeader: React.FC<CompanyViewInfoHeaderProps> = ({ name, url }): ReactElement => (
    <div className="company-view-info__header">
        <div className="company-view-info__company-name">
            {name}
        </div>
        {url && (
            <div className="company-view-info__url">
                <Link href={addUtmtoURL(url)} target="_blank" rel="nofollow noopener" title={url} className="company-view-info__url-link">
                    {url.replace(/^https?:\/\//, '')}
                </Link>
            </div>
        )}
    </div>
);

export default CompanyViewInfoHeader;
